import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import cn from 'classnames';
import Tooltip from '@omilia/tooltip';
import TextCropper from '@omilia/text-cropper';

import { entityType } from 'types';
import ArchivedIcon from 'components/SelectableList/components/ArchivedIcon';
import ListActionsMenu from 'components/ListActionsMenu';

import './style.scss';

export default class EntityItem extends Component {
  static propTypes = {
    isArchived: PropTypes.bool,
    model: entityType,
    triggerModal: PropTypes.func,
  };

  shouldComponentUpdate(nextProps) {
    const { model } = this.props;
    return !_isEqual(nextProps.model, model);
  }

  render() {
    const {
      isArchived,
      // eslint-disable-next-line camelcase
      model: {
        id,
        name,
        xpack_resource,
        contains_dictionary_connections,
        color,
      },
      triggerModal,
    } = this.props;

    /* eslint-disable camelcase */
    return (
      <div
        data-test="entity-element"
        styleName={cn('item', {
          'is-archived': isArchived,
        })}
      >
        <div
          data-test="entity-color"
          style={{ background: color }}
          styleName="item__mark"
        />
        <div styleName="item__name">
          <TextCropper
            data-test="entity-name"
            styleName="cropper"
            text={name}
          />
          {xpack_resource && <sup data-test="xpack-indicator">XP</sup>}
        </div>
        <div styleName="item__icons">
          {isArchived && <ArchivedIcon name="Entity" />}
          {!contains_dictionary_connections && (
            <Tooltip
              content={
                <React.Fragment>
                  Unlinked
                  <br />
                  Entity
                </React.Fragment>
              }
              placement="left"
            >
              <span className="icon-unlinked" data-test="unlinked-icon" />
            </Tooltip>
          )}
        </div>
        <ListActionsMenu
          items={[
            {
              name: 'Replace with',
              onClick: () => triggerModal(id),
            },
          ]}
        />
      </div>
    );
  }
}
